import { ReactNode, useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { useWindowSize } from 'usehooks-ts'

const gradientheight = 300
const textcolumnpadding = 60

const gradients = {
  light: {
    top: 'linear-gradient(180deg,rgba(255, 255, 255, 0) 0%,rgba(255, 255, 255, 1) 100%)',
    bottom:
      'linear-gradient(180deg,rgba(255, 255, 255, 1) 0%,rgba(255, 255, 255, 0) 100%)',
  },
  dark: {
    top: 'linear-gradient(180deg,rgba(18,18,18, 0) 0%,rgba(18,18,18, 1) 100%)',
    bottom:
      'linear-gradient(180deg,rgba(18,18,18, 1) 0%,rgba(18,18,18, 0) 100%)',
  },
}

export const Reveal = ({
  cover,
  gradient,
  colorMode = 'light',
  images,
  wrapper,
  overlayContent,
}: {
  cover?: boolean
  gradient?: boolean
  colorMode?: 'light' | 'dark'
  images: string[]
  wrapper?: ReactNode
  overlayContent?: ReactNode
}) => {
  const frontRef = useRef<HTMLDivElement>(null)
  const imgRef = useRef<HTMLImageElement>(null)
  const centerRef = useRef<HTMLDivElement>(null)
  const lupeContainerRef = useRef<HTMLDivElement>(null)

  const [frontheight, setFrontheight] = useState(0)
  const [imgheight, setImgheight] = useState(0)

  const [windowHeight, setWindowHeight] = useState(0)
  const windowSize = useWindowSize()
  const isMobile = windowSize.width < 712
  useEffect(() => {
    if (frontRef.current) setFrontheight(frontRef.current?.offsetHeight || 0)
    if (imgRef.current) setImgheight(imgRef.current?.offsetHeight || 0)


    setWindowHeight(windowSize.height)
  }, [])
  useEffect(() => {
    setWindowHeight(windowSize.height)
  }, [windowSize.width])
  useEffect(() => {
    setFrontheight(frontRef.current?.offsetHeight || 0)
  }, [frontRef.current])
  useEffect(() => {
    if (!imgRef.current) return

    setImgheight(imgRef.current?.offsetHeight || 0)
  }, [imgRef.current])

  return (
    <Container>
      <Back
        style={{
          height: 2 * frontheight + windowHeight + 'px',
        }}
        ref={centerRef}
      >
        <Center
          style={{
            maxHeight: windowHeight * 0.8 + 'px',
            paddingTop:
              (cover ? windowHeight * 0.1 : windowHeight * 0.1) +
              (windowSize.width < 712 ? 40 : 60) +
              'px',
            // paddingBottom: cover ? windowHeight * 0.1 + 60 + 'px' : 'unset',
          }}
        >
          <img
            ref={imgRef}
            src={windowSize.width < 712 ? images[0] : images[1]}
            style={{
              // width: 'unset',
              // minWidth: 'unset',
            
              maxHeight: windowSize.width < 712 ? windowHeight * 0.9 :windowHeight * 0.8 + 'px',
            }}
          />
        </Center>
      </Back>
      <Front
        style={
          cover
            ? { bottom: 0, paddingTop: textcolumnpadding + 'px' }
            : { top: 0, paddingBottom: textcolumnpadding + 'px' }
        }
      >
        <FrontElement ref={frontRef}>{overlayContent}</FrontElement>
        <>
          {gradient && (
            <FadeOut
              style={
                cover
                  ? {
                      background: gradients[colorMode].top,
                      height: gradientheight + 'px',
                      top: -gradientheight - textcolumnpadding + 'px',
                    }
                  : {
                      background: gradients[colorMode].bottom,
                      height: gradientheight + 'px',
                      bottom: -gradientheight - textcolumnpadding + 'px',
                    }
              }
            />
          )}
        </>
      </Front>
    </Container>
  )
}

const NoWrapper = ({ children }: { children: ReactNode }) => {
  return <>{children}</>
}

const Source = styled.div`
  font-family: var(--font-sans-serif);
  font-size: 12px;
  color: var(--gray-3);
  margin-bottom: 60px;
  text-align: left;
  line-height: 21px;
  width: 100%;
`
const Title = styled.div`
  font-family: var(--font-sans-serif);
  font-size: 15px;
  color: var(--text-color);
  text-align: left;
  width: 100%;
  line-height: 21px;
  margin-top: 10px;
`

const Container = styled.div`
  position: relative;
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
  width: 100%;
`
const Back = styled.div.attrs({ className: 'back' })`
  width: 100%;
  height: 100%;
  z-index: 1;
  position: relative;
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
  background-color: var(--inlay-bg);
`
const Center = styled.div.attrs({ className: 'Center' })`
  display: flex;
  justify-content: flex-end;
  align-content: center;
  position: sticky;
  top: 0;
  right: 0;
  /* width: 100%; */
  /* left:50%;
  transform: translateX(-50%); */
  /* max-width: 1500px; */
  overflow: hidden;
  flex-direction: column;
  transition: all 0.3s ease-in-out;
  img {
    /* max-height: 100%; */
  }
  @media (max-width: 712px) {
    justify-content: center;
    display: inline-block;
    width: 100%;
    /* max-width: 100vw;
    width: auto; */
    text-align: center;
  
    img{

      margin-left: auto;
      margin-right: auto;
      width: auto;
    }
    /* max-width: 100% */
    /* img {
      transition: all 1s ease-in-out;
      height: unset;
      max-height: unset;
      min-height: unset;
      max-width: 100vw;
    } */
  }
  @media (min-width: 900px) {
    right: unset;
    align-items: center;
  }
`

const FadeOut = styled.div.attrs({ className: 'fadeout' })`
  left: 0;
  position: absolute;
  bottom: -200px;

  width: 100vw;
  height: 200px;
  z-index: 100;
  /* background-color: #f00; */
`
const Front = styled.div`
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;

  left: 0;
  right: 0;
  background-color: var(--site-background);
`

const FrontElement = styled.div<{
  distanceTop?: number
  distanceBottom?: number
}>`
  display: inline-block;
  align-items: center;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  padding: 0px;
  background-color: var(--site-background);
  position: relative;

  z-index: 1;
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
`
